const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    requestResetCode(username, email, platform, langCode) {
      const url = getUrl('sendResetCode');
      const reqOpts = {
        headers: merge(headers, {Authorization: getWs02Token()}),
        method: 'POST'
      };
      const body = {
        userId: username,
        emailId: email,
        platform: platform,
        lang: langCode
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    verifyResetCode(resetCodeId, resetCodeValue) {
      const url = getUrl('verifyResetCode');
      const reqOpts = {
        headers: merge(headers, {Authorization: getWs02Token()}),
        method: 'POST'
      };
      const body = {
        resetCodeId: resetCodeId.slice(10),
        resetCodeValue: resetCodeValue.slice(10),
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    verifyResetCodeExtended(resetCodeId, resetCodeValue, channel) {
      const url = getUrl('verifyResetCode');
      const reqOpts = {
        headers: merge(headers, {Authorization: getWs02Token()}),
        method: 'POST'
      };
      const body = {
        resetCodeId: resetCodeId.slice(10),
        resetCodeValue: resetCodeValue.slice(10),
        channel: channel
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
    
    resendResetCode(resetCodeId, langCode) {
      const url = getUrl('resendResetCode');
      const reqOpts = {
        headers: merge(headers, {Authorization: getWs02Token()}),
        method: 'POST'
      };
      const body = {
        resetCodeId: resetCodeId.slice(10),
        lang: langCode
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    changePassword(token, userId, newCryptoPassword, langCode, metaData) {
      const url = getUrl('changePassword');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers ),
        method: 'POST'
      };
      const body = {
        token: token.slice(6),
        userId: userId,
        newDbPassword: newCryptoPassword.slice(5),
        lang: langCode
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    }
  };
}

module.exports = apiFactory;
